import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { tokenName, identifierModuleUrl } from "@angular/compiler";
import { UrlModal } from "src/app/shared/url.model";

@Injectable({
  providedIn: "root"
})
export class PatientsService {
  //  URL = "http://localhost:3005";
  URL = "http://206.189.132.38:3005";

  constructor(private httpClient: HttpClient) {}
  savePatientsToDb(
    name,
    // email,
    // password,
    phoneNo,
    userType,
    chargeable,
    token
  ) {
    console.log("SAVE PATIENT SERVICE", chargeable);
    return this.httpClient.post(
      UrlModal._URL + "/ad/regpatbyadmin",
      {
        name: name,
        // email: email,
        // password: password,
        phoneNo: phoneNo,
        userType: userType,
        chargeable: chargeable
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token
        })
      }
    );
  }
  getPatientsFromDb(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");

    return this.httpClient
      .get<patientData>(
        UrlModal._URL + "/pat/getpat/",

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token
          }),
          params: params
        }
      )
      .pipe(
        map(res => {
          return {
            patData: res.data.docs,
            page: res.data.page,
            total: res.data.total
          };
        })
      );
  }
  getSinglePatient(id: string, token: string) {
    return this.httpClient.post<singlePatientData>(
      UrlModal._URL + "/ad/getadminsinglepat/",
      {
        id: id
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token
        })
      }
    );
  }
  updatePatientsToDb(name, phoneNo, userType, chargeable, token, id) {
    return this.httpClient.put(
      UrlModal._URL + "/ad/adminupdatepatient",
      {
        name: name,
        // email: email,
        // password: password,
        id: id,
        phoneNo: phoneNo,
        userType: userType,
        chargeable: chargeable
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token
        })
      }
    );
  }
  deletePatient(id, token) {
    return this.httpClient.post(
      UrlModal._URL + "/ad/admindeletepat",
      {
        id: id
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token
        })
      }
    );
  }
  onSearchPatient(value, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");

    return this.httpClient
      .get<patientData>(
        UrlModal._URL + "/pat/searchpatient/" + value + "/",

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token
          }),
          params: params
        }
      )
      .pipe(
        map(res => {
          return {
            patData: res.data.docs,
            page: res.data.page,
            total: res.data.total
          };
        })
      );
  }
}

export interface patientData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        name: string;
        // email: string;
        phoneNo: number;
        userType: string;
        chargeable: string;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}
export interface singlePatientData {
  status: number;
  message: string;
  data: {
    _id: string;
    isDeleted: boolean;
    isEnabled: boolean;
    name: string;
    // query: string;
    // email: string;
    regBy: string;
    phoneNo: number;
    userType: string;
    chargeable: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
